import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteTypesMutationProps = {
	ids: number[]
	onSettled: () => void
}

export const useDeleteTypesMutation = ({ ids, onSettled }: UseDeleteTypesMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteTypesMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.post(apiRoutes.typesDelete, { ids })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Types deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.types.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteTypesMutation
	}
}
